import type {FeatureFlags} from "./types.ts";

/**
 * Parse flags_on and flags_off query parameters into a map of flags.
 *
 * This function takes in a record of query parameters and builds a map of
 * flags to the given flag start as described by the query parameters.
 * The flags can be provided as comma-separated values under the keys
 * "flags_on" and "flags_off", or multiple instances of the keys.
 *
 * @param queryParams - A record of query parameters from the URL.
 * @returns A map of flag to boolean indicating whether the flag is on or off.
 */
export function queryParamsToFeatureFlags(
    queryParams: URLSearchParams,
): FeatureFlags {
    const featureFlags: FeatureFlags = {};
    for (const flags of queryParams.getAll("flags_on")) {
        for (const flag of flags.split(",")) {
            featureFlags[flag] = true;
        }
    }
    for (const flags of queryParams.getAll("flags_off")) {
        for (const flag of flags.split(",")) {
            featureFlags[flag] = false;
        }
    }
    return featureFlags;
}
